var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDersehazir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0976 0L20.2927 7.80488V24.9756L28.0976 17.9512V0ZM31.2195 6.2439V27.3171C29.5024 26.7707 27.6293 26.5366 25.7561 26.5366C23.1024 26.5366 19.278 27.5512 17.1707 28.878V7.80488C14.9073 6.0878 11.6293 5.46341 8.58537 5.46341C5.54146 5.46341 2.26341 6.0878 0 7.80488V30.6732C0 31.0634 0.390244 31.4537 0.780488 31.4537C0.936585 31.4537 1.01463 31.3756 1.17073 31.3756C3.27805 30.361 6.32195 29.6585 8.58537 29.6585C11.6293 29.6585 14.9073 30.2829 17.1707 32C19.278 30.6732 23.1024 29.6585 25.7561 29.6585C28.3317 29.6585 30.9854 30.1268 33.1707 31.2976C33.3268 31.3756 33.4049 31.3756 33.561 31.3756C33.9512 31.3756 34.3415 30.9854 34.3415 30.5951V7.80488C33.4049 7.10244 32.3902 6.63415 31.2195 6.2439ZM14.0488 27.1766C12.0976 26.6771 10.1463 26.5366 8.58537 26.5366C6.93073 26.5366 4.9639 26.8332 3.12195 27.3171V9.56878C4.54244 8.94439 6.46244 8.58537 8.58537 8.58537C10.7083 8.58537 12.6283 8.94439 14.0488 9.56878V27.1766Z",
    fill: "#3733BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDersehazir);
export default __webpack_public_path__ + "static/media/dersehazir.21bc3661ee6f3ef2008544e15fb19f76.svg";
export { ForwardRef as ReactComponent };